import * as trackingTools from './tracking-tools';

export const enableCookieConsent = () => {
    (function () {
        window.addEventListener("load", function () {

            const palette = {
                "popup": {
                    "background": "rgba(156, 165, 168, .95)",
                    "text": "#000"
                },
                "button": {
                    "background": "rgba(156, 165, 168, .95)",
                    "text": "#000"
                }
            };

            const content = {};
            setContentText(content);

            window.cookieconsent.initialise({
                palette: palette,
                content: content,
                showLink: false,
                type: 'opt-in',
                onStatusChange: function (status) {
                    if (status === 'allow') {
                        if (!trackingTools.isGoogleAnalyticsLoaded()) {
                            trackingTools.enableGoogleAnalytics();
                        }
                    } else {
                        window.ga = undefined;
                    }
                }
            });
        });

        function setContentText(content) {
            if (isHtmlLang(["sv", "SV", "se", "SE"])) {
                content.message = "Vår webbplats använder <a href='cookies-sv/'><u>cookies</u></a> för att förbättra användarupplevelsen.";
                content.deny = "Avvisa";
                content.allow = "Tillåt";
            } else if (isHtmlLang(["fi", "FI"])) {
                content.message = "Verkkosivustomme käyttää <a href='cookies-fi/'><u>evästeitä</u></a> parantaakseen käyttäjäkokemusta.";
                content.deny = "Hylkää";
                content.allow = "Salli";
            } else {
                content.message = "Our website uses <a href='cookies-en/'><u>cookies</u></a> to improve user experience.";
                content.deny = "Decline";
                content.allow = "Allow";
            }
        }

        function isHtmlLang(locales) {
            for (let i = 0; i < locales.length; i++) {
                var htmlLang = document.documentElement.lang;
                if (!htmlLang) {
                    continue;
                }
                if (htmlLang.indexOf(locales[i]) > -1) {
                    // found lang
                    return true
                }
            }
            return false;
        }
    })();
};
